module.exports = __webpack_public_path__ + "img/23.4692895d.jpg";